import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconImagesRight: React.FC<SvgIconProps> = ({sx}) => (
  <SvgIcon
    viewBox="0 0 22 49"
    sx={{
      width: 22, 
      height: 49,
      ...sx,
    }}
  >
    <rect opacity="0.25" x="22" y="49" width="22" height="49" rx="8" transform="rotate(-180 22 49)" fill="white" />
    <path 
        d="M7 15.5708L7 34.4292C7 35.3412 8.12089 35.7772 8.73716 35.1049L17.3806 25.6757C17.731 25.2934 17.731 24.7066 17.3806 24.3243L8.73716 14.8951C8.12089 14.2228 7 14.6588 7 15.5708Z" 
        opacity="0.25"
        fill="#D4E8F1"
    />
  </SvgIcon>
)
